import { render, staticRenderFns } from "./Top5InsectsPanel.vue?vue&type=template&id=e070cf6e&scoped=true&"
import script from "./Top5InsectsPanel.vue?vue&type=script&lang=js&"
export * from "./Top5InsectsPanel.vue?vue&type=script&lang=js&"
import style0 from "./Top5InsectsPanel.vue?vue&type=style&index=0&id=e070cf6e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e070cf6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e070cf6e')) {
      api.createRecord('e070cf6e', component.options)
    } else {
      api.reload('e070cf6e', component.options)
    }
    module.hot.accept("./Top5InsectsPanel.vue?vue&type=template&id=e070cf6e&scoped=true&", function () {
      api.rerender('e070cf6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/Dashboard/Top5InsectsPanel/Top5InsectsPanel.vue"
export default component.exports